/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Waiting_For_Permission_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo is in the meeting but may not record yet. The organiser has to allow it in Zoom." |
*
* @param {Meeting_Notetaker_Issue_Waiting_For_Permission_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_waiting_for_permission_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Waiting_For_Permission_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Waiting_For_Permission_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo zit in de meeting, maar mag nog niet opnemen. De organisator moet dat toelaten in Zoom.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo est dans la réunion, mais n'a pas encore le droit d'enregistrer. L'organisateur doit l'autoriser dans Zoom.")
	return /** @type {LocalizedString} */ ("Wundo is in the meeting but may not record yet. The organiser has to allow it in Zoom.")
});